import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import Footer from '../Footer';

// Locale
import messages from '../../locale/messages';
import { FooterToggleGlobalSvg, FooterToggleCloseSvg } from './FooterSvgComponent';


import s from './FooterToggle.css';

class FooterToggle extends Component {

    constructor() {
        super();
        this.state = {
            open: false
        };
    }

    toggleDrawer = () => {
        this.setState({ open: !this.state.open });
    }
    render() {
        return (
            <>
                <button
                    onClick={this.toggleDrawer}
                    className={cx(s.footerDrawerCloseOpenBtn, 'footerDrawerCloseOpenBtnRTL')}
                >
                    {!this.state.open ?
                        <>
                            <FooterToggleGlobalSvg />
                            <span className='hidden-xs'><FormattedMessage {...messages.footerTerms} /></span>
                        </>
                        :
                        <>
                            <FooterToggleCloseSvg />
                            <span className='hidden-xs'><FormattedMessage {...messages.footerClose} /></span>
                        </>
                    }
                </button>
                <div className={cx(s.footerCustomDrawer, this.state.open && s.footerDrawerOpen)}>
                    <Footer />
                </div>
            </>
        );
    }
}
export default injectIntl(withStyles(s)(FooterToggle));